import React, { useState } from "react";
import { Grid, IconButton, InputBase, Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import SearchIcon from "@mui/icons-material/Search";
import { useDebounceFn } from "./helpers";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    margin: "5px 10px 0px",
  },
  paper: {
    padding: "0px 4px",
    display: "flex",
    alignItems: "center",
    border: "1px solid #ECEBEB",
    boxShadow: "none !important",
    margin: "3px 0px 5px",
  },
  inputBase: {
    marginLeft: theme.spacing(1),
    flexGrow: 1,
    fontSize: "14px",
    fontWeight: 400,
    "&::placeholder": {
      fontSize: "14px",
    },
  },

  span: {
    fontSize: "0.7rem",
    fontFamily: "system-ui",
    fontWeight: 500,
  },
}));

const SearchFilter = ({
  handleSearch,

  placeHolder,
  name = "search",
  quickSearch = false,
}) => {
  const classes = useStyles();
  const [internalSearch, setInternalSearch] = useState("");
  const handleInternalSearch = (event) => {
    setInternalSearch(event.target.value);
    if (event.target.value === "") {
      handleSearch?.(event);
    } else if (quickSearch) {
      handleDelayUpdate?.(event);
    }
  };
  const handleDelayUpdate = useDebounceFn((event) => {
    handleSearch?.(event);
  });

  const handleKeyPress = (event) => {
    if (
      event.key === "Enter" ||
      (event.keyCode === 32 && event.target.selectionStart == 0)
    ) {
      handleSearch?.(event);
      event.preventDefault();
    }
  };
  const handleIconClick = () => {
    handleSearch?.({
      target: {
        name: name,
        value: internalSearch,
      },
    });
  };
  return (
    <Grid container direction="column" className={classes.root}>
      <Paper
        component="form"
        className={classes.paper}
        onKeyDown={handleKeyPress}
      >
        <InputBase
          name={name}
          onChange={handleInternalSearch}
          className={classes.inputBase}
          value={internalSearch}
          placeholder={placeHolder}
        />
        <IconButton type="button" aria-label="search" onClick={handleIconClick}>
          <SearchIcon />
        </IconButton>
      </Paper>
      {!quickSearch && (
        <span className={classes.span}>
          Press Enter key to search after typing
        </span>
      )}
    </Grid>
  );
};

export default SearchFilter;
